
import "./Coffre.scss";

import { Component } from "react";
import clsx from 'clsx';
import { getPositionFromIndex, objPosition } from '../GameplayUtils';
import GameplayManager from "../GameplayManager";
import { CodeQuestions } from '../../../interfaces/ILabyData';

interface ITuileCoffreProps{    
    gpl_manager:GameplayManager; 
    index:number;     
    codeQuestion:CodeQuestions;
}
type TTuileCoffreState = {
    vieRestante:number;
    coffreVisible:boolean;
}

class TuileCoffre extends Component<ITuileCoffreProps,TTuileCoffreState> {

  gpl_manager:GameplayManager;
  index:number;    
  position:objPosition = {colonne:0, ligne:"X"};
  codeQuestion:CodeQuestions;
  intervalTimeOut:any;

  state:TTuileCoffreState = this.getInitialState();
  constructor(props:any){
    super(props);
    this.gpl_manager = props.gpl_manager;
    this.index = props.index;
    this.position = getPositionFromIndex(this.index);
    this.codeQuestion = this.props.codeQuestion;
  }
  getInitialState():TTuileCoffreState{
    return{
        vieRestante:10,
        coffreVisible:true
    }
  }

  fairePasserLeTemps = () => {
    const empecherEcoulementDutemps = (
      this.gpl_manager.gameManager.getIsPopupOuvert() ||
      !this.gpl_manager.gameManager.getIsWindowActive()
    )
    
    if (empecherEcoulementDutemps) return;
    const ancienTemps = this.state.vieRestante;
    const nouveauTemps = ancienTemps - 1;
    if (nouveauTemps < 1){
        this.setState({coffreVisible:false});
        this.gpl_manager.retirerCoffreCode(this.codeQuestion);
        this.gpl_manager.gameManager.updateCoffreHudStatus(this.codeQuestion, "timedout");        
        this.gpl_manager.app.audioManager.current?.play("coffre_disparait");
        if (this.intervalTimeOut) clearInterval(this.intervalTimeOut);
    } else {
        this.setState({vieRestante:nouveauTemps});
    }
  }

  componentDidMount(){     
    this.setState({
        vieRestante:10,
        coffreVisible:true
    });
    const decompte = (window.innerWidth < 1180) ? 3000: 2000;
    this.intervalTimeOut = setInterval(this.fairePasserLeTemps, decompte);
  }

  componentWillUnmount(){
    if (this.intervalTimeOut) clearInterval(this.intervalTimeOut);
  }

  getClassPosition(){
    return `tuile_pos_x_${this.position.colonne} tuile_pos_y_${this.position.ligne}`
  }

  
  render() {    
    return (this.state.coffreVisible &&
        <div 
            className={clsx("tuileCoffre", this.getClassPosition(), `vie${this.state.vieRestante}`)}
            data-code={this.codeQuestion}
            data-valeur={this.state.vieRestante}
            data-position={`${this.position.ligne}${this.position.colonne}`}   
            data-colonne={this.position.colonne}   
            data-ligne={this.position.ligne}           
        ><span className={`vie${this.state.vieRestante}`}>{this.state.vieRestante}</span></div>
    )
  }
}

export default TuileCoffre;
